import { Fragment } from 'react';
import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { KpiCard } from './kpi-card';
import { KpiCardProps } from './types';

export interface KpiCardsContainerProps {
  kpiConfig: KpiCardProps[];
  isLoading?: boolean;
  customContainerStyles?: ReturnType<typeof css>;
}

export const KpiCardsContainer = ({ kpiConfig, isLoading = false, customContainerStyles }: KpiCardsContainerProps) => {
  return (
    <div css={[styles.wrapper, customContainerStyles]}>
      {kpiConfig.map((config, index) => (
        <Fragment key={config.title}>
          <KpiCard {...config} isLoading={isLoading} />
          {index < kpiConfig.length - 1 && (
            <span css={styles.chevron}>
              <Icon name='caret-right-small' size={24} />
            </span>
          )}
        </Fragment>
      ))}
    </div>
  );
};

const styles = {
  wrapper: css`
    display: flex;
    align-items: stretch;

    @media (max-width: ${breakpoints.large.min}px) {
      flex-wrap: wrap;
      gap: ${theme.spacing(2)};
    }
  `,

  chevron: css`
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    padding: 0 ${theme.spacing(0.5)};

    @media (max-width: ${breakpoints.large.min}px) {
      display: none;
    }
  `,
};
